<template>
    <div class="error-content">
        <h2>{{msg}}</h2>
    </div>
</template>

<script>
    export default {
        name: 'error_401',
        data () {
            return {
                msg: '401'
            }
        }
    }
</script>
